export default __webpack_public_path__ + "static/media/elevate-dmb-banner-3.6b5b313b.jpg";